import { useEffect, useState } from "react";

import { useAuth } from '@artegeie/mrc/context';
import { Account } from '@artegeie/mrc/profile';

import useMrcAuth from 'Hooks/useMrcAuth';
import useTranslation from 'Hooks/useTranslation';

import Loader from 'Components/Layout/Loader';

import 'scss/components/content/account.scss';
import 'scss/components/content/_account-status.scss';

export default function AccountStatus() {

	const { user } = useAuth();

	const { t } = useTranslation();
	const authMrc = useMrcAuth();


	// loader
	const { loader } = window.appConfig;
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		if ( authMrc.token ) {
			setLoading(false);
		}
	}, [ authMrc.token ] );

	setTimeout(
		() => setLoading(false),
		loader.timeout
	);

	return (

		<div id='account-page' className="account-status">
			{ loading && <Loader /> }
			{ authMrc.loginState && <p>{ t('account.welcome.hello') } {user.firstName} {user.lastName}.</p> }
			{ authMrc.loginState && <Account /> }
		</div>
	);
};
